import React from "react";
import WeekMonthTabs from "../filter-tabs/WeekMonthTabs";
import DropDown from "../../../../../Components/UI/DropDown";
import { MonthlySchedulerProps } from "../../../../../types/interfaces/IMonthScheduleProps.interface";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
import moment from "moment";
import FilterShifts from "../filter-tabs/FilterShifts";
import { months } from "../../../../../utils/months";
import { generateWeeks } from "../../../../../utils/weeks";

const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-gray-600">
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
  </svg>
);
const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-gray-600">
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
  </svg>
);

export let data: any;
const NurseScheduleHeader: React.FC<MonthlySchedulerProps> = ({
  year,
  month,
  setYear,
  setMonth,
  week,
  setWeek,
}) => {
  const selectedCalendar = useSelector(
    (state: RootState) => state.time.selectedCalendar
  );

  function getWeeksInMonth() {
    const firstDay = new Date(+year?.year, +month?.label - 1, 1);
    const lastDay = new Date(+year?.year, +month?.label, 0);
    return Math.ceil(lastDay.getDate() / 7);
  }

  const numberOfWeeks = getWeeksInMonth();
  const weeks = generateWeeks(numberOfWeeks);
  data = Array.from({ length: numberOfWeeks }, (_, index) => ({
    name: `Week ${index + 1}`,
    weekLabel: "Week",
    label: index + 1,
  }));

  // Month navigation
  const monthIdx = months.findIndex((m) => +m.label === +month.label);
  const handlePrevMonth = () => { if (monthIdx > 0) setMonth(months[monthIdx - 1] as any); };
  const handleNextMonth = () => { if (monthIdx < months.length - 1) setMonth(months[monthIdx + 1] as any); };

  // Year navigation
  const currentYearNum = +year.year;
  const minYear = Number(moment().format("YYYY")) - 5;
  const maxYear = Number(moment().format("YYYY")) + 5;
  const handlePrevYear = () => {
    if (currentYearNum > minYear)
      setYear({ ...year, name: currentYearNum - 1, year: currentYearNum - 1, label: "year" } as any);
  };
  const handleNextYear = () => {
    if (currentYearNum < maxYear)
      setYear({ ...year, name: currentYearNum + 1, year: currentYearNum + 1, label: "year" } as any);
  };

  return (
    <div className="py-[14px] px-4 md:px-7 shadow-moon-lg relative z-10">
      <div className="flex flex-wrap gap-[10px] items-center w-full">
        {selectedCalendar === "week" && (
          <div className="max-w-[140px] md:max-w-[173px] w-full">
            <DropDown field={"name"} value={week} options={weeks} setOptions={setWeek} />
          </div>
        )}

        {/* Month arrow control */}
        <div className="flex items-center gap-1">
          <button onClick={handlePrevMonth} disabled={monthIdx <= 0}
            className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 transition-colors" aria-label="Previous month">
            <ChevronLeft />
          </button>
          <span className="text-sm font-semibold text-gray-700 min-w-[80px] text-center select-none">
            {month.monthName}
          </span>
          <button onClick={handleNextMonth} disabled={monthIdx >= months.length - 1}
            className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 transition-colors" aria-label="Next month">
            <ChevronRight />
          </button>
        </div>

        {/* Year arrow control */}
        <div className="flex items-center gap-1">
          <button onClick={handlePrevYear} disabled={currentYearNum <= minYear}
            className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 transition-colors" aria-label="Previous year">
            <ChevronLeft />
          </button>
          <span className="text-sm font-semibold text-gray-700 min-w-[44px] text-center select-none">
            {currentYearNum}
          </span>
          <button onClick={handleNextYear} disabled={currentYearNum >= maxYear}
            className="p-1 rounded hover:bg-gray-100 disabled:opacity-30 transition-colors" aria-label="Next year">
            <ChevronRight />
          </button>
        </div>

        <div className="flex items-center gap-[10px] flex-1 justify-between">
          <FilterShifts />
          <WeekMonthTabs />
        </div>
      </div>
    </div>
  );
};

export default NurseScheduleHeader;
